<template>
  <div class="loading" v-show="$store.state.isLoading">
    <img src="@/assets/loading.gif" alt="Loading..." />
  </div>
  <router-view></router-view>
</template>
<style lang="scss">
.loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  opacity: 0.7;
  background-color: #fff;
  z-index: 99;
  text-align: center;
  display: block;
  /* Option v-bind:class
  display: none;
  &.is-active {
    display: block;
  }*/
}

.loading img {
  position: absolute;
  width: 5vw;
  height: 5vw;
  z-index: 100;
  margin-left: 47.5%;
  margin-top: 45vh;
}
</style>
<script>
export default {
  name: "App",
  beforeCreate() {
    this.$store.dispatch('getCrsf');
    this.$store.commit('getLocalStorage');
    this.$store.commit('getAllDates');
  },
}
</script>